import { render, staticRenderFns } from "./familyTable.vue?vue&type=template&id=641c1124&scoped=true"
import script from "./familyTable.vue?vue&type=script&lang=js"
export * from "./familyTable.vue?vue&type=script&lang=js"
import style0 from "./familyTable.vue?vue&type=style&index=0&id=641c1124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c1124",
  null
  
)

export default component.exports